import React from "react";
import { TextField, Grid, Typography } from "@material-ui/core";

const Dashboard = (props) => {
  return (
    <div className={{flexDirection: 'row'}}>
      <Typography style={{fontSize: 17}}>Olá, {props.user.name}. Lembre-se que os dados que tem acesso são confidenciais e da sua responsabilidade de manter sigilo. </Typography>
    </div>
  );
};

export default Dashboard;
